(ns pfo.chat.core (:require
                   [pfo.util :as util]
                   [pfo.chat.component :as component]
                   ))

(defn chat [{:keys [query-params]}]
  (util/set-page #'component/chat query-params))

(defn artifact-download [{:keys [id]}]
  (util/set-page #'component/artifact-download {:id id}))
